import { FC, JSX } from 'react';
import { FieldPath, useFormContext } from 'react-hook-form';

import { StylesConfig } from '@player/content';

import Arrow2 from '@/shared/ui/icons/Arrow2';

import { ColorSetting } from './Settings';

interface Props {}

type FormWithConfig = { config: StylesConfig };

const ColorsSettings: FC<Props> = (): JSX.Element => {
  const formMethods = useFormContext<FormWithConfig>();

  return (
    <div className="flex flex-col gap-2">
      <div className="text-sm font-semibold">Colors</div>
      <div className="flex flex-col gap-2 rounded-lg bg-black/[.02] py-3 dark:bg-white/[.02]">
        <div className="flex gap-2 pe-4 ps-2">
          <Arrow2 height={28} />
          <ColorSetting
            title="Primary"
            propName={'config.colors.primary' as FieldPath<FormWithConfig>}
            {...formMethods}
          />
        </div>

        <div className="flex gap-2 pe-4 ps-2">
          <Arrow2 height={28} />
          <ColorSetting
            title="Secondary"
            propName={'config.colors.secondary' as FieldPath<FormWithConfig>}
            {...formMethods}
          />
        </div>
      </div>
    </div>
  );
};

export default ColorsSettings;
